/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Empty_Dates_Body_MilestonesInputs */

const en_tl_empty_dates_body_milestones = /** @type {(inputs: Tl_Empty_Dates_Body_MilestonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a target date on a milestone to place it on the timeline; its items line up before it. Drag items from Unscheduled to give them their own dates.`)
};

const de_tl_empty_dates_body_milestones = /** @type {(inputs: Tl_Empty_Dates_Body_MilestonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setze ein Zieldatum für einen Meilenstein, um ihn auf die Zeitleiste zu bringen; seine Vorgänge reihen sich davor ein. Zieh Vorgänge aus Ohne Termin, um ihnen eigene Termine zu geben.`)
};

/**
* | output |
* | --- |
* | "Set a target date on a milestone to place it on the timeline; its items line up before it. Drag items from Unscheduled to give them their own dates." |
*
* @param {Tl_Empty_Dates_Body_MilestonesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_empty_dates_body_milestones = /** @type {((inputs?: Tl_Empty_Dates_Body_MilestonesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Empty_Dates_Body_MilestonesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_empty_dates_body_milestones(inputs)
	return en_tl_empty_dates_body_milestones(inputs)
});